import React, { useState, useEffect } from 'react'
import defaultPortrait from '../../assets/default_portrait.png'
import defaultPortraitGM from '../../assets/default_portrait_gm.png'

import './Avatar.css'

const Avatar = ({id, name, ownerId, avatarUrl, kind, initiative, initiativePriority, isOwner, isGM, onUpdateInitiative, isHidden, scale = 1.0}) => {
  let portrait = ownerId === id ? defaultPortraitGM : defaultPortrait
  const [editingInitiative, setEditingInitiative] = useState(false)
  const [initiativeValue, setInitiativeValue] = useState(initiative)

  // Keep local state synchronized with prop when not editing
  useEffect(() => {
    if (!editingInitiative) {
      setInitiativeValue(initiative)
    }
  }, [initiative, editingInitiative])

  const handleInitiativeDoubleClick = () => {
    if (isGM) {
      setEditingInitiative(true)
      setInitiativeValue(initiative)
    }
  }

  const handleSave = () => {
    const parsed = parseInt(initiativeValue)
    if (!isNaN(parsed) && parsed !== initiative && onUpdateInitiative) {
      onUpdateInitiative(id, parsed)
    }
    setEditingInitiative(false)
    setInitiativeValue(initiative) // Reset to original if invalid
  }

  const renderInitiative = (isOwner, initiative, initiativePriority) => {
    // If editing, show input regardless of owner status
    if (editingInitiative) {
      return (
        <input
          type="text"
          value={initiativeValue}
          onChange={(e) => setInitiativeValue(e.target.value)}
          onBlur={handleSave}
          onFocus={(e) => e.target.select()}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSave()
            if (e.key === 'Escape') {
              setEditingInitiative(false)
              setInitiativeValue(initiative)
            }
          }}
          autoFocus
          style={{ width: '50px', fontSize: `${12 * scale}px`, textAlign: 'center' }}
        />
      )
    }

    // Show initiative with double-click handler
    if (isOwner) {
      return (
        <div
          className='Avatar__initiative Avatar__initiative--gm'
          style={{ fontSize: `${12 * scale}px`, cursor: isGM ? 'pointer' : 'default' }}
        >
          {initiative}-{initiativePriority}
        </div>
      )
    } else {
      return (
        <div
          className='Avatar__initiative'
          style={{ fontSize: `${12 * scale}px`, cursor: isGM ? 'pointer' : 'default' }}
        >
          {initiative}
        </div>
      )
    }
  }

  if (avatarUrl) {
    portrait = avatarUrl
  }

  if (kind === 'party') {
    const initiativeDisplay = renderInitiative(isOwner, initiative, initiativePriority)
    const portraitClass = 'Avatar__portrait Avatar__portrait--party'
    const style = {
      width: `${100 * scale}px`,
      height: `${100 * scale}px`
    }

    return(
      <div
        className='Avatar'
        onDoubleClick={handleInitiativeDoubleClick}
        style={{
          cursor: isGM ? 'pointer' : 'default',
          opacity: (isGM && isHidden) ? 0.4 : 1,
          transition: 'opacity 0.2s'
        }}
      >
        <img src={portrait} className={portraitClass} style={style} />
        <div className='Avatar__name' style={{ fontSize: `${12 * scale}px`, paddingTop: `${8 * scale}px` }}>{name}</div>
        {initiativeDisplay}
      </div>
    )
  } else if (kind === 'roll') {
    return <img src={portrait} className='Avatar__portrait Avatar__portrait--roll' />
  }
}

export default Avatar